<script setup lang="ts">
import MPFooter from "~/components/layouts/MPFooter.vue";
import MPHeader from "~/components/layouts/MPHeader.vue";
</script>

<template>
  <div class="flex-wrapper">
    <div class="header">
      <MPHeader />
    </div>
    <slot>
      <NuxtPage />
    </slot>
    <div class="footer">
      <MPFooter />
    </div>
  </div>
</template>

<style lang="postcss" scoped>
@import "@/assets/css/breakpoints.pcss";

.flex-wrapper {
  display: flex;
  min-height: 100vh;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
}
.flex-wrapper:deep(header) {
  width: 100%;
}
.footer {
  margin-top: auto;
  display: none;
  @mixin screen md {
    display: block;
  }
}
</style>
